import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../../components/layout/DashboardLayout';
import PageHeader from '../../components/common/PageHeader';
import { getPendingOffers } from '../../services/messageService';
import { useI18n } from '../../i18n/I18nContext';

const PendingOffers = () => {
  const { t } = useI18n();
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const data = await getPendingOffers();
        setOffers(Array.isArray(data) ? data : []);
        setError(null);
      } catch (e) {
        setError(t('offers.errors.loadFailed'));
      } finally {
        setLoading(false);
      }
    })();
  }, [t]);

  return (
    <DashboardLayout>
      <div className="container-fluid">
        <PageHeader title={t('offers.pending.title')} subtitle={t('offers.pending.subtitle')} />
        {loading && <div className="text-muted p-4">{t('common.loading')}</div>}
        {!loading && error && <div className="alert alert-danger">{error}</div>}
        {!loading && !error && offers.length === 0 && (
          <div className="text-muted p-4">{t('offers.pending.noOffers')}</div>
        )}
        <div className="list-group">
          {offers.map(o => (
            <button key={o.id} className="list-group-item list-group-item-action d-flex justify-content-between align-items-center" onClick={() => navigate(`/offers/${o.id}`)}>
              <div>
                <div className="fw-semibold">{o.expediteurEnterpriseName || `${t('clientOffers.expediteur')} #${o.expediteurId}`}</div>
                <div className="text-muted small">{o.missionSummary}</div>
              </div>
              <span className="badge bg-primary rounded-pill">{t('common.view')}</span>
            </button>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default PendingOffers;
